import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { SignInCompletedResponse } from './SignInCompletedResponse'
import { BeginChallengeResponse } from './BeginChallengeResponse'
/**
* Class SignInBeginResponse
*  Результат запроса на вход в систему. <para /> Обязательно содержит либо Web.Api.Showcases.Controllers.Auth.Models.SignInBeginResponse.Completed, либо Web.Api.Showcases.Controllers.Auth.Models.SignInBeginResponse.Confirmation
*/
export class SignInBeginResponse extends ActiveModel {

  /**
  * completed
  * Если значение присутствует, то значит авторизация была завершена и в этом св-ве указаны аутентификационные данные<br>  */
  @ActiveField({
    factory: [SignInCompletedResponse, () => undefined]
  })
  completed?: null | SignInCompletedResponse


  /**
  * confirmation
  * Если значение присутствует, то требуется подтвердить вход в систему<br>  */
  @ActiveField({
    factory: [BeginChallengeResponse, () => undefined]
  })
  confirmation?: null | BeginChallengeResponse
}
